export default {
  "admin.title": "Panel de administración",
  "admin.overview": "Resumen",
  "admin.providers": "Proveedores",
  "admin.bookings": "Reservas",
  "admin.reviews": "Reseñas",
  "admin.coupons": "Cupones",
  "admin.salesTotal": "Ventas totales",
  "admin.salesToday": "Ventas de hoy",
  "admin.activeProviders": "Proveedores activos",
  "admin.pendingProviders": "Pendientes",
  "admin.totalCustomers": "Clientes",
  "admin.totalTours": "Tours activos",
  "admin.commission": "Comisión",
  "admin.commissionRate": "Tasa de comisión",
  "admin.recentBookings": "Reservas recientes",
  "admin.recentReviews": "Reseñas recientes",
  "admin.providerName": "Proveedor",
  "admin.providerEmail": "Correo",
  "admin.providerStatus": "Estado",
  "admin.providerVerified": "Verificado",
  "admin.providerActions": "Acciones",
  "admin.approve": "Aprobar",
  "admin.reject": "Rechazar",
  "admin.suspend": "Suspender",
  "admin.activate": "Activar",
  "admin.search": "Buscar...",
  "admin.filter": "Filtrar",
  "admin.all": "Todos",
  "admin.couponCode": "Código",
  "admin.couponDiscount": "Descuento",
  "admin.couponExpiry": "Vence",
  "admin.couponUsage": "Usos",
  "admin.addCoupon": "Nuevo cupón",
  "admin.reviewTour": "Tour",
  "admin.reviewUser": "Usuario",
  "admin.reviewRating": "Calif.",
  "admin.reviewComment": "Comentario",
  "admin.reviewDate": "Fecha",
  "admin.reviewActions": "Acciones",
  "admin.approveReview": "Aprobar",
  "admin.rejectReview": "Rechazar",
  "admin.settings": "Configuración",
  "admin.settingsDesc": "Personaliza la plataforma",
  "admin.platformName": "Nombre de la plataforma",
  "admin.contactEmail": "Correo de contacto",
  "admin.bookingCommission": "Comisión por reserva",
  "admin.commissionDesc": "Porcentaje que retiene la plataforma de cada reserva",
  "admin.currency": "Moneda principal",
  "admin.defaultLanguage": "Idioma por defecto",
  "admin.bookingSettings": "Reservas",
  "admin.bookingSettingsDesc": "Reglas para nuevas reservas",
  "admin.autoConfirm": "Confirmación automática",
  "admin.autoConfirmDesc": "Aprobar reservas sin revisión manual",
  "admin.cancellationPeriod": "Cancelación gratuita hasta",
  "admin.hoursBefore": "horas antes",
  "admin.maxGuests": "Máximo de huéspedes por reserva",
  "admin.notificationSettings": "Notificaciones",
  "admin.notificationSettingsDesc": "Correos que recibe el administrador",
  "admin.emailNewBooking": "Nueva reserva",
  "admin.emailNewBookingDesc": "Recibir correo cuando hay una nueva reserva",
  "admin.emailNewProvider": "Nuevo proveedor",
  "admin.emailNewProviderDesc": "Recibir correo cuando un proveedor se registra",
  "admin.emailNewReview": "Nueva reseña",
  "admin.emailNewReviewDesc": "Recibir correo cuando publican una reseña",
  "admin.emailDailyReport": "Reporte diario",
  "admin.emailDailyReportDesc": "Recibir resumen diario de ventas",
  "admin.paymentMethods": "Métodos de pago",
  "admin.paymentMethodsDesc": "Configura integraciones de pago",
  "admin.mercadoPago": "Mercado Pago",
  "admin.mercadoPagoDesc": "Pagos con tarjeta, OXXO y SPEI",
  "admin.mpPublicKey": "Public Key",
  "admin.mpPublicKeyHint": "Usa la clave pública de tu aplicación en Mercado Pago",
  "admin.mpAccessToken": "Access Token",
  "admin.mpAccessTokenHint": "Token de acceso para procesar pagos desde el backend",
  "admin.mpWebhookUrl": "URL del webhook",
  "admin.mpWebhookHint": "Configura esta URL en el panel de Mercado Pago",
  "admin.mpTestMode": "Modo de prueba",
  "admin.mpTestModeDesc": "Usa credenciales de prueba sin cobros reales",
  "admin.mpConnected": "Conectado",
  "admin.mpLastChecked": "Última verificación",
  "admin.saveSettings": "Guardar cambios",
  "admin.noData": "No hay datos",
  "admin.page": "Página",
  "admin.of": "de",

  // Shared
  "admin.loading": "Cargando…",
  "admin.view": "Ver",
  "admin.save": "Guardar",
  "admin.saving": "Guardando…",
  "admin.saved": "Guardado.",

  // Auditoría
  "admin.aud.title": "Auditoría",
  "admin.aud.search": "Buscar por ruta o usuario…",
  "admin.aud.date": "Fecha",
  "admin.aud.method": "Método",
  "admin.aud.path": "Ruta",
  "admin.aud.user": "Usuario",
  "admin.aud.ip": "IP",
  "admin.aud.status": "Estado",
  "admin.aud.empty": "Sin registros de auditoría.",

  // Comisiones
  "admin.com.title": "Comisiones",
  "admin.com.pending": "Pendiente por liquidar",
  "admin.com.settledTotal": "Total liquidado",
  "admin.com.providers": "Proveedores",
  "admin.com.provider": "Proveedor",
  "admin.com.pendingBookings": "Reservas pend.",
  "admin.com.pendingNet": "Pendiente (neto)",
  "admin.com.settledNet": "Liquidado (neto)",
  "admin.com.empty": "Aún no hay comisiones registradas. Se generan cuando una reserva pasa a Completada.",
  "admin.com.settle": "Marcar liquidado",
  "admin.com.settling": "Liquidando…",
  "admin.com.upToDate": "Al día",

  // Productos
  "admin.prod.title": "Productos",
  "admin.prod.search": "Buscar por título o proveedor…",
  "admin.prod.tour": "Tour",
  "admin.prod.provider": "Proveedor",
  "admin.prod.category": "Categoría",
  "admin.prod.price": "Precio",
  "admin.prod.status": "Estado",
  "admin.prod.empty": "Sin productos.",
  "admin.prod.statusActive": "Activo",
  "admin.prod.statusPaused": "Pausado",
  "admin.prod.statusArchived": "Archivado",

  // Categorías de tours
  "admin.cat.title": "Categorías",
  "admin.cat.desc": "Categorías del catálogo (conjunto fijo). Conteo de tours activos por categoría.",
  "admin.cat.viewTours": "Ver tours",
  "admin.cat.tours": "tours",
  "admin.cat.adventure": "Aventura",
  "admin.cat.cultural": "Cultural",
  "admin.cat.gastronomic": "Gastronómico",
  "admin.cat.transport": "Transporte",
  "admin.cat.housing": "Renta de Casas",
  "admin.cat.fishing": "Pesca",

  // Destinos
  "admin.dest.title": "Destinos",
  "admin.dest.desc": "Destinos con tours activos en el catálogo (derivado de las ubicaciones de los tours).",
  "admin.dest.destination": "Destino",
  "admin.dest.activeTours": "Tours activos",
  "admin.dest.empty": "Sin destinos con tours activos.",

  // Usuarios
  "admin.users.title": "Usuarios",
  "admin.users.search": "Buscar por nombre o email…",
  "admin.users.name": "Nombre",
  "admin.users.email": "Email",
  "admin.users.role": "Rol",
  "admin.users.bookings": "Reservas",
  "admin.users.marketing": "Ofertas",
  "admin.users.marketingYes": "Acepta",
  "admin.users.marketingNo": "No acepta",
  "admin.users.joined": "Registro",
  "admin.users.empty": "Sin usuarios.",
  "admin.users.tourist": "Turista",
  "admin.users.provider": "Proveedor",
  "admin.users.admin": "Admin",

  // Reportes
  "admin.rep.title": "Reportes",
  "admin.rep.tabSales": "Ventas",
  "admin.rep.tabCommissions": "Comisiones",
  "admin.rep.tabProviders": "Top Proveedores",
  "admin.rep.tabProducts": "Top Productos",
  "admin.rep.tabUsers": "Crecimiento",
  "admin.rep.export": "Exportar reservas (CSV)",
  "admin.rep.exporting": "Exportando…",
  "admin.rep.totalSales": "Ventas totales",
  "admin.rep.totalBookings": "Reservas totales",
  "admin.rep.avgTicket": "Ticket promedio",
  "admin.rep.monthlySales": "Ventas mensuales",
  "admin.rep.noSales": "Sin datos de ventas todavía.",
  "admin.rep.totalCommission": "Comisión total",
  "admin.rep.commission30d": "Comisión (30 días)",
  "admin.rep.takeRate": "Tasa de comisión",
  "admin.rep.monthlyCommission": "Comisión mensual",
  "admin.rep.topProvidersTitle": "Proveedores con mayor facturación",
  "admin.rep.topProvidersDesc": "Top 10 por monto neto acumulado. El número a la derecha es la cantidad de reservas liquidadas y pendientes.",
  "admin.rep.noProviders": "Todavía no hay pagos registrados.",
  "admin.rep.topProductsTitle": "Productos más vendidos",
  "admin.rep.topProductsDesc": "Top 10 por venta bruta acumulada. El número a la derecha es la cantidad de reservas.",
  "admin.rep.noProducts": "Todavía no hay reservas registradas.",
  "admin.rep.totalUsers": "Usuarios totales",
  "admin.rep.activeProviders": "Proveedores activos",
  "admin.rep.activeTours": "Tours activos",
  "admin.rep.monthlyBookings": "Reservas por mes",

  // Notificaciones (broadcast)
  "admin.notif.title": "Notificaciones",
  "admin.notif.send": "Enviar anuncio",
  "admin.notif.desc": "Crea una notificación que aparecerá en el centro de notificaciones de los destinatarios.",
  "admin.notif.recipients": "Destinatarios",
  "admin.notif.providers": "Proveedores",
  "admin.notif.clients": "Clientes",
  "admin.notif.allAudience": "Todos (proveedores y clientes)",
  "admin.notif.subject": "Título",
  "admin.notif.subjectPlaceholder": "p. ej. Mantenimiento programado",
  "admin.notif.message": "Mensaje",
  "admin.notif.messagePlaceholder": "Escribe el anuncio…",
  "admin.notif.sending": "Enviando…",
  "admin.notif.sentTo": "Enviado a {{count}} usuario(s).",
  "admin.notif.error": "No se pudo enviar el anuncio.",

  // Configuración
  "admin.cfg.title": "Configuración",
  "admin.cfg.general": "General",
  "admin.cfg.platformName": "Nombre de la plataforma",
  "admin.cfg.supportEmail": "Email de soporte",
  "admin.cfg.defaultCommission": "Comisión por defecto (%)",
  "admin.cfg.commissionHint": "Se aplica a los proveedores que se registren a partir de ahora.",
  "admin.cfg.currency": "Moneda",
  "admin.cfg.commissionRange": "La comisión debe estar entre 0 y 100.",
  "admin.cfg.saveError": "No se pudo guardar.",

  // Configuración — respaldo de base de datos
  "admin.cfg.dbTitle": "Base de datos",
  "admin.cfg.dbDesc": "Descarga una copia completa de la base de datos (estructura y datos) en un archivo .sql. Guárdalo en un lugar seguro; contiene toda la información de la plataforma.",
  "admin.cfg.dbExport": "Descargar respaldo (.sql)",
  "admin.cfg.dbExporting": "Generando…",
  "admin.cfg.dbExportError": "No se pudo generar el respaldo.",
  "admin.cfg.dbExportDone": "Respaldo descargado.",

  // Contenido (tours destacados)
  "admin.content.title": "Contenido",
  "admin.content.heading": "Tours destacados en la página de inicio",
  "admin.content.search": "Buscar tour o proveedor…",
  "admin.content.tour": "Tour",
  "admin.content.provider": "Proveedor",
  "admin.content.featured": "Destacado",
  "admin.content.empty": "Sin tours.",
  "admin.content.featureTour": "Destacar tour",

  // Configuración — moneda
  "admin.cfg.currencyMxn": "MXN — Peso mexicano",
  "admin.cfg.currencyUsd": "USD — Dólar estadounidense",

  // Layout / navegación
  "admin.nav.dashboard": "Dashboard",
  "admin.nav.providers": "Proveedores",
  "admin.nav.products": "Productos",
  "admin.nav.bookings": "Reservas",
  "admin.nav.users": "Usuarios",
  "admin.nav.commissions": "Comisiones",
  "admin.nav.coupons": "Cupones",
  "admin.nav.events": "Eventos",
  "admin.nav.reviews": "Reseñas",
  "admin.nav.categories": "Categorías",
  "admin.nav.destinations": "Destinos",
  "admin.nav.reports": "Reportes",
  "admin.nav.notifications": "Notificaciones",
  "admin.nav.content": "Contenido",
  "admin.nav.settings": "Configuración",
  "admin.nav.audit": "Auditoría",
  "admin.roleLabel": "Administrador",
  "admin.roleAdmin": "Admin",
  "admin.backToSite": "Volver al sitio",

  // Dashboard (page.tsx)
  "admin.loadError": "No pudimos cargar el panel.",
  "admin.lifetimeGross": "Ventas brutas (total)",
  "admin.pendingReview": "por verificar",
  "admin.activeTours": "Tours activos",
  "admin.totalUsers": "usuarios totales",
  "admin.gross30d": "Ventas últimos 30 días",
  "admin.commission30d": "Comisión últimos 30 días",
  "admin.bookings30d": "Reservas últimos 30 días",
  "admin.monthlyChart": "Ventas por mes (últimos 12)",
  "admin.noRevenueYet": "Aún no hay ingresos para graficar.",
  "admin.gross": "Ventas brutas",
  "admin.seeAll": "Ver todas",
  "admin.noBookings": "Aún no hay reservas.",
  "admin.refColumn": "Ref",
  "admin.customer": "Cliente",
  "admin.tour": "Tour",
  "admin.provider": "Proveedor",
  "admin.total": "Total",
  "admin.status": "Estado",
  "admin.date": "Fecha",
  "admin.actions": "Acciones",
  "admin.noMatches": "Sin coincidencias con los filtros.",

  // Estados de reserva
  "admin.statusConfirmed": "Confirmada",
  "admin.statusPending": "Pendiente",
  "admin.statusCompleted": "Completada",
  "admin.statusCancelled": "Cancelada",

  // Proveedores (page.tsx + DocumentsPanel)
  "admin.statusActive": "Activo",
  "admin.statusSuspended": "Suspendido",
  "admin.confirmVerify": "¿Verificar y activar este proveedor?",
  "admin.actionError": "Error al ejecutar la acción.",
  "admin.suspendReason": "Motivo de la suspensión (opcional):",
  "admin.searchPlaceholder": "Buscar por empresa, email o ubicación",
  "admin.noProviders": "Sin coincidencias.",
  "admin.companyColumn": "Empresa",
  "admin.ownerColumn": "Dueño",
  "admin.locationColumn": "Ubicación",
  "admin.toursColumn": "Tours",
  "admin.revenueColumn": "Ventas",
  "admin.commissionColumn": "Comisión",
  "admin.verify": "Verificar",
  "admin.reactivate": "Reactivar",
  "admin.docs": "Docs",
  "admin.hideDocs": "Ocultar docs",
  "admin.docTypeIne": "INE",
  "admin.docTypeProofOfAddress": "Comprobante de domicilio",
  "admin.docTypeCurp": "CURP",
  "admin.docTypeActaConstitutiva": "Acta constitutiva",
  "admin.docVerified": "Verificado",
  "admin.docRejected": "Rechazado",
  "admin.docInReview": "En revisión",
  "admin.docsLoading": "Cargando documentos…",
  "admin.docsEmpty": "Sin documentos subidos.",
  "admin.docVerify": "Verificar",
  "admin.docReject": "Rechazar",
  "admin.docRejectReason": "Motivo del rechazo (opcional):",

  // Cupones (page.tsx)
  "admin.cou.title": "Cupones",
  "admin.cou.new": "Nuevo cupón",
  "admin.cou.edit": "Editar cupón",
  "admin.cou.loadError": "No pudimos cargar los cupones.",
  "admin.cou.empty": "Aún no hay cupones. Crea el primero.",
  "admin.cou.code": "Código",
  "admin.cou.discount": "Descuento",
  "admin.cou.validity": "Validez",
  "admin.cou.uses": "Usos",
  "admin.cou.status": "Estado",
  "admin.cou.active": "Activo",
  "admin.cou.inactive": "Inactivo",
  "admin.cou.editAction": "Editar",
  "admin.cou.deactivate": "Desactivar",
  "admin.cou.noExpiry": "sin caducidad",
  "admin.cou.until": "hasta {{date}}",
  "admin.cou.from": "desde {{date}}",
  "admin.cou.description": "Descripción (opcional)",
  "admin.cou.discountType": "Tipo de descuento",
  "admin.cou.percent": "Porcentaje",
  "admin.cou.fixed": "Monto fijo",
  "admin.cou.percentLabel": "Porcentaje (1–100)",
  "admin.cou.amountLabel": "Monto (MXN)",
  "admin.cou.validFrom": "Desde",
  "admin.cou.validUntil": "Hasta",
  "admin.cou.maxUses": "Usos máximos (opcional)",
  "admin.cou.noLimit": "Sin límite",
  "admin.cou.activeLabel": "Activo",
  "admin.cou.cancel": "Cancelar",
  "admin.cou.save": "Guardar",
  "admin.cou.confirmDeactivate": "¿Desactivar el cupón {{code}}?",
  "admin.cou.errCodeRequired": "El código es requerido.",
  "admin.cou.errPercentRange": "El porcentaje debe estar entre 1 y 100.",
  "admin.cou.errAmountPositive": "El monto debe ser mayor a 0.",
  "admin.cou.errSave": "Ocurrió un error al guardar.",

  // Reseñas (page.tsx)
  "admin.res.title": "Reseñas",
  "admin.res.loadError": "No pudimos cargar las reseñas.",
  "admin.res.empty": "No hay reseñas en esta vista.",
  "admin.res.tabPending": "Pendientes",
  "admin.res.tabApproved": "Aprobadas",
  "admin.res.tabRejected": "Rechazadas",
  "admin.res.tabAll": "Todas",
  "admin.res.sourceVerified": "Verificada",
  "admin.res.statusApproved": "Aprobada",
  "admin.res.statusRejected": "Rechazada",
  "admin.res.statusPending": "Pendiente",
  "admin.res.approve": "Aprobar",
  "admin.res.reject": "Rechazar",
  "admin.res.withdraw": "Retirar",

  // Reportes — encabezados CSV
  "admin.rep.csvReference": "Referencia",
  "admin.rep.csvDate": "Fecha",
  "admin.rep.csvTour": "Tour",
  "admin.rep.csvProvider": "Proveedor",
  "admin.rep.csvCustomer": "Cliente",
  "admin.rep.csvEmail": "Email",
  "admin.rep.csvAdults": "Adultos",
  "admin.rep.csvChildren": "Niños",
  "admin.rep.csvTotal": "Total",
  "admin.rep.csvCommission": "Comisión",
  "admin.rep.csvCurrency": "Moneda",
  "admin.rep.csvStatus": "Estado",
};